var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"rounded-b-0"},[_c('v-card-title',{staticClass:"align-start"},[_c('span',[_vm._v("Total No. of Tissue and Transplant ")]),_c('v-spacer')],1),_c('v-card-text',[_c('div',{attrs:{"id":"pie-chart"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }